<div
  class="switch"
  [ngClass]="{ 'is-active': value }"
  (click)="toggleSwitch()"
  [attr.role]="'switch'"
  [attr.aria-checked]="value ? value : false"
  tabindex="0"
></div>
